<template>
  <div v-if="viewMode === 'list'" class="col-12 col-md-6 mt-3">
    <div class="list-row d-flex align-items-center justify-content-between">
      <router-link
        class="list-row-content d-flex align-items-center cursor-pointer text-decorator"
        :event="option.needSelectedStudent && !hasSelectedStudent ? '' : 'click'"
        :to="option.route"
        @click="goToRoute(option.route)"
      >
        <img class="list-row-icon rounded-circle" :src="showImage(option.mainImage)" />
        <span class="list-row-title">{{ option.title }}</span>
      </router-link>
      <span v-if="showStar" class="star font-20">
        <div v-if="!option.isFavorite">
          <i
            class="fa-solid fa-star fill cursor-pointer"
            @click="$emit('add')"
          ></i>
          <i class="fa-regular fa-star unfill cursor-pointer"></i>
        </div>
        <div v-else>
          <i
            class="fa-solid fa-star text-warning cursor-pointer"
            @click="$emit('remove')"
          ></i>
        </div>
      </span>
    </div>
  </div>
  <div v-else class="flip-card col-lg-3 col-md-6 mt-4">
    <div class="flip-card-inner" :class="rotateCard ? 'card-rotate' : ''">
      <div>
        <div class="flip-card-front position-relative">
          <span
            v-if="showStar"
            class="star font-20 d-flex justify-content-end mr-3 mt-2 position-absolute col-md-12 col-lg-12 col-sm-12"
          >
            <div v-if="!option.isFavorite">
              <i
                class="fa-solid fa-star fill cursor-pointer"
                @click="$emit('add')"
              ></i>
              <i class="fa-regular fa-star unfill cursor-pointer"></i>
            </div>
            <div v-else>
              <i
                class="fa-solid fa-star text-warning cursor-pointer"
                @click="$emit('remove')"
              ></i>
            </div>
          </span>
          <router-link
            class="text-decorator"
            :event="
              option.needSelectedStudent && !hasSelectedStudent ? '' : 'click'
            "
            :to="option.route"
            @click="goToRoute(option.route)"
          >
            <div class="col-xs-7">
              <img class="rounded-circle" :src="showImage(option.mainImage)" />
              <h3 class="card-front-title">
                {{ option.title }}
              </h3>
              <p class="px-4 card-front-p mb-3">
                {{ option.description }}
              </p>
            </div>
          </router-link>
        </div>
        <div class="flip-card-back">
          <div class="text-right">
            <img class="rounded-circle" :src="showImage(option.hoverImage)" />
          </div>
          <h3 class="card-back-title">
            {{ option.title }}
          </h3>
          <p class="card-back-p px-4 pb-2">
            {{ option.detail }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  /** Componente común de opciones en tarjeta */
  name: 'SquareOption',
  props: {
    /** Establece las opciones del SquareOption */
    option: {
      type: Object,
      default: () => ({}),
      meta: {
        description: '',
        example: 'this.SquareData',
      },
    },
    showStar: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: String,
      default: 'grid',
      validator: (value) => ['grid', 'list'].includes(value),
    },
  },
  data() {
    return {
      hasSelectedStudent: false,
    }
  },
  computed: {
    rotateCard() {
      return this.option.rotate == undefined ? true : this.option.rotate
    },
  },
  methods: {
    goToRoute(route) {
      if (!this.hasSelectedStudent && this.option.needSelectedStudent) {
        event.stopImmediatePropagation()
        return
      }
      this.$router.push(route).catch(() => {})
    },
    showImage(imgName) {
      try {
        return require(`@/assets/img/${imgName}`)
      } catch {
        return require('@/assets/logo.svg')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.unfill {
  color: #b5c3bc;
}

.fill {
  color: #f8b539;
}

.star:hover .unfill,
.star .fill {
  display: none;
}

.star:hover .fill {
  display: inline;
}

.text-decorator {
  text-decoration: none;
}

.option-title {
  font-size: 12.5px;
}

.menu-item {
  height: 115px;
  width: 225px;
}

/**flip card effect**/
.flip-card {
  background-color: transparent;
  padding-left: 45px;
  height: auto;
  margin-left: -15px;
  perspective: 1000px;
  /* Remove this if you don't want the 3D effect */

  /*Other browsers*/
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  -ms-perspective: 1000;
  perspective: 1000;

  -ms-transform: perspective(1000px);
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
}

/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;

  /*Other browsers*/
  -webkit-transition: 0.8s;
  -webkit-transform-style: preserve-3d;
  -ms-transition: 0.8s;

  -moz-transition: 0.8s;
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;

  transition: 0.8s;
  transform-style: preserve-3d;

  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
}

/* Position the front and back side */
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 237px !important;
  backface-visibility: hidden;

  /*Other browsers*/
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;

  -webkit-transition: 0.8s;
  -webkit-transform-style: preserve-3d;

  -moz-transition: 0.8s;
  -moz-transform-style: preserve-3d;

  -o-transition: 0.8s;
  -o-transform-style: preserve-3d;

  -ms-transition: 0.8s;
  -ms-transform-style: preserve-3d;

  transition: 0.8s;
  transform-style: preserve-3d;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
  background: transparent linear-gradient(180deg, #ffffff 0%, #f2f2f2 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  color: black;
  height: auto;
  height: 237px !important;

  -webkit-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  /*	background-position: center center;
			z-index: 2;*/
}

.card-front-title {
  color: #2db782;
  font: Bold 14px/17px Lato;
}

.card-front-p {
  font: 12px/16px Lato;
  letter-spacing: 0;
  color: black;
}

.card-back-title {
  color: white;
  font: Bold 14px/17px Lato;
  margin-top: -10px;
}

.card-back-p {
  font: 12px Lato;
  letter-spacing: 0;
  color: #ffffff;
}

/* Style the back side */
.flip-card-back {
  background-image: linear-gradient(to top, #007a50, #02b47d);
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3c7552;
  border-radius: 5px;
  color: white;
  height: auto;

  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(-180deg);
}

.cursor-pointer {
  cursor: pointer;
}

/**End of flip card effect**/

.list-row {
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 0px 3px 6px #00000014;
  min-height: 64px;
  padding: 10px 20px;
}

.list-row-content {
  flex: 1;
}

.list-row-icon {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  object-fit: cover;
}

.list-row-title {
  color: #11291b;
  font: Bold 14px/17px Lato;
  text-align: left;
}
</style>
